import React, { Suspense, lazy } from 'react'
import { WhatsAppContext, WhatsAppContextProps } from 'components/WhatsAppButton/WhatsAppContext'
import { Loading, NavBar, RootBackgroundImage } from '../'
import { Script } from 'gatsby-script'

const Footer = lazy(() => import('../Footer'))

export interface LayoutProps {
  children: React.ReactNode
  whatsAppContextValue?: WhatsAppContextProps
}

export const Layout = ({ children, whatsAppContextValue = {} }: LayoutProps) => {
  return (
    <WhatsAppContext.Provider value={whatsAppContextValue}>
      <RootBackgroundImage>
        <NavBar />
        <div>{children}</div>
        <Suspense fallback={<Loading />}>
          <Footer />
        </Suspense>
      </RootBackgroundImage>
    </WhatsAppContext.Provider>
  )
}

export default Layout
